export enum FeatureName {
  fxFeature = 'fxFeature',
  beforeUnloadAlert = 'beforeUnloadAlert',
  newMessageScreens = 'newMessageScreens',
  newMessageScreensForCreate = 'newMessageScreensForCreate'
}
